export default {
  // ページの説明
  summary: {
    en: 'Displaying system-wide statistics and summary',
    ja: 'システム全体の統計とサマリーを表示しています',
  },

  // ダッシュボードカード
  cards: {
    totalPrograms: {
      en: 'Total Programs',
      ja: '総プログラム数',
    },
    totalPlaylists: {
      en: 'Total Playlists',
      ja: '総プレイリスト数',
    },
    activePlaylists: {
      en: 'Active Playlists',
      ja: 'アクティブなプレイリスト',
    },
    newProgramsThisMonth: {
      en: 'New Programs This Month',
      ja: '今月の新規プログラム',
    },
  },

  // チャート
  charts: {
    programsByMonth: {
      en: 'Programs Created by Month',
      ja: '月別プログラム作成数',
    },
    playlistStatus: {
      en: 'Playlist Status',
      ja: 'プレイリストの状態',
    },
  },

  // チャートラベル
  status: {
    active: {
      en: 'Active',
      ja: 'アクティブ',
    },
    draft: {
      en: 'Draft',
      ja: '下書き',
    },
    expired: {
      en: 'Expired',
      ja: '期限切れ',
    },
  },
};
